<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/A5IId8/cover.jpeg?1685327736266" alt="This image is the cover for the book The Deserted Land, Volume 2"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Deserted Land, Volume 2
      </h1>
      <p class="bookDescription body article font2">
        <p>In the abandoned domain of the Mysterious Sky Continent's god race, the humans and demons continued to fight endlessly. The evil spirits had awoken unexpectedly, and the evil races from the foreign lands would descend upon the Profound Heaven Continent. Human youths occasionally obtained divine blood and became disciples of the Great Void Sect. Everything began here.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jian Xian, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6ea239cc